/* eslint-disable react-refresh/only-export-components */
import { isArrayStrictlyEqual } from '@/lib/equality';
import type { ReactNode } from 'react';
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

export interface Breadcrumb {
  label: string;
  href?: string;
}

export interface AppBarStore {
  breadcrumbs: Breadcrumb[];
  setBreadcrumbs: (_: Breadcrumb[]) => void;
}

const AppBarContext = createContext({} as AppBarStore);

export function AppBarProvider({ children }: { children: ReactNode }) {
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);
  const lastBreacrumbs = useRef<Breadcrumb[]>([]);
  const updateBreadcrumbs = (breadcrumbs: Breadcrumb[]) => {
    if (isArrayStrictlyEqual(lastBreacrumbs.current, breadcrumbs)) {
      return;
    }

    lastBreacrumbs.current = breadcrumbs;
    setBreadcrumbs(breadcrumbs);
  };

  return React.createElement(
    AppBarContext.Provider,
    {
      value: {
        breadcrumbs,
        setBreadcrumbs: updateBreadcrumbs,
      },
    },
    children,
  );
}

export function useAppBarState() {
  return useContext(AppBarContext);
}

export function useSetBreadcrumbs(breadcrumbs: Breadcrumb[]) {
  const store = useAppBarState();
  const setBreadcrumbs = store.setBreadcrumbs;
  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [setBreadcrumbs, breadcrumbs]);
}
